import ScreenLoading from '@/lib/ui/screen-loading.tsx';

export function LoadingLogin({ loading }: { loading: boolean }) {
  if (loading) {
    return <ScreenLoading />;
  }

  return null;
}
